// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1WRqN","welcomediv":"App_welcomediv__3oN30","welcome":"App_welcome__OXuSE"};